import { Pipe, PipeTransform } from '@angular/core';
import { StatutEvenement } from '../evenements.interface';

@Pipe({
  name: 'evenementStatutClass',
  standalone: true,
})
export class EvenementStatutClassPipe implements PipeTransform {
  transform(statutEvenement: StatutEvenement): string {
    switch (statutEvenement) {
      case StatutEvenement.AControler:
        return 'capsKo';
      case StatutEvenement.ARedditionner:
        return 'capsInfo';
      case StatutEvenement.Acompte:
        return 'capsInfo';
      case StatutEvenement.AcompteEnCours:
        return 'capsInfo';
      case StatutEvenement.EnCours:
        return 'capsWait';
      case StatutEvenement.Redditionne:
        return 'capsOk';
      case StatutEvenement.Reverse:
        return 'capsOk';
      case StatutEvenement.GereManuellement:
        return 'capsWait';
      default:
        return 'capsKo';
    }
  }
}
